var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.581 330.323h-16.517c-22.804 0-41.29-18.486-41.29-41.29 0-13.682 11.092-24.774 24.774-24.774h33.032v66.064z",
    fill: "#3c91be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.387 0h-305.548l-8.506 16.516v487.484h388.377l16.516-8.516v-404.645z",
    fill: "#e9f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.839 470.71v-470.71c-9.121 0-16.516 7.394-16.516 16.516v478.968c0 9.122 7.395 16.516 16.516 16.516h379.871c9.121 0 16.516-7.395 16.516-16.516h-371.613c-13.683 0-24.774-11.092-24.774-24.774z",
    fill: "#d9edff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.097 313.806h-305.549c-2.896 0-5.676-.497-8.26-1.41l-8.063 13.354v103.476c.001 13.682 11.093 24.774 24.775 24.774h297.097l16.516-8.065v-115.612c0-9.122-7.395-16.517-16.516-16.517z",
    fill: "#7dc3ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.613 264.258h-181.678c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h181.677c4.565 0 8.258 3.698 8.258 8.258s-3.693 8.258-8.257 8.258z",
    fill: "#64acdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.613 222.968h-181.678c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h181.677c4.565 0 8.258 3.698 8.258 8.258.001 4.56-3.693 8.258-8.257 8.258z",
    fill: "#7dc3ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.613 181.677h-66.065c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h66.065c4.565 0 8.258 3.698 8.258 8.258s-3.694 8.258-8.258 8.258z",
    fill: "#64acdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.613 140.387h-66.065c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h66.065c4.565 0 8.258 3.698 8.258 8.258 0 4.561-3.694 8.258-8.258 8.258z",
    fill: "#7dc3ee"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.718 429.734c-2.177 0-4.266-.859-5.815-2.395-1.556-1.544-2.435-3.641-2.444-5.831 0 0-.089-24.181-.089-33.452l-.048-33.258c-.008-2.194.863-4.298 2.411-5.851 1.548-1.552 3.653-2.423 5.847-2.423h18.887c21.048 0 35.194 16.718 35.194 41.605 0 23.673-14.508 41.105-34.492 41.456-5.419.093-19.419.149-19.419.149-.008 0-.024 0-.032 0zm8.129-66.694.04 25.016c0 5.746.032 17.238.056 25.117 3.976-.024 8.403-.06 10.935-.105 12.621-.218 18.266-12.685 18.266-24.94 0-12.129-4.903-25.089-18.677-25.089h-10.62z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m292.161 430.75c-23.5 0-42.621-19.121-42.621-42.621s19.121-42.621 42.621-42.621c8.54 0 16.782 2.52 23.831 7.286 3.782 2.552 4.774 7.685 2.218 11.468-2.54 3.774-7.694 4.766-11.46 2.218-4.315-2.915-9.363-4.456-14.589-4.456-14.395 0-26.105 11.71-26.105 26.105s11.71 26.105 26.105 26.105c5.347 0 9.839-1.593 13.363-4.73.71-.633 1.355-1.306 1.96-2.024 2.919-3.476 8.129-3.948 11.629-1.016 3.492 2.931 3.952 8.141 1.016 11.637-1.121 1.339-2.331 2.593-3.629 3.746-6.54 5.818-14.96 8.903-24.339 8.903z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m194 430.75c-23.5 0-42.621-19.121-42.621-42.621s19.121-42.621 42.621-42.621 42.621 19.121 42.621 42.621-19.121 42.621-42.621 42.621zm0-68.726c-14.395 0-26.105 11.71-26.105 26.105s11.71 26.105 26.105 26.105 26.105-11.71 26.105-26.105-11.71-26.105-26.105-26.105z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.258 173.419h-66.065c-4.561 0-8.258-3.697-8.258-8.258v-33.032c0-4.561 3.697-8.258 8.258-8.258h66.065c4.561 0 8.258 3.697 8.258 8.258v33.032c0 4.561-3.697 8.258-8.258 8.258z",
    fill: "#7dc3ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.226 89.421c0-4.38-1.74-8.581-4.838-11.679l-72.908-72.905c-3.097-3.097-7.298-4.837-11.678-4.837h-1.415v82.581c0 4.56 3.697 8.258 8.258 8.258h82.581z",
    fill: "#d9edff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#64acdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.29 312.396c-9.6-3.413-16.516-12.593-16.516-23.364v148.645c0 13.682 11.092 24.774 24.774 24.774h305.548c9.121 0 16.516-7.395 16.516-16.516h-305.547c-13.682 0-24.774-11.092-24.774-24.774v-108.765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.968 165.161c-13.682 0-24.774-11.092-24.774-24.774v-16.516h-8.258c-4.561 0-8.258 3.697-8.258 8.258v41.29c0 4.561 3.697 8.258 8.258 8.258h74.323c4.561 0 8.258-3.697 8.258-8.258v-8.258z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.bd7dbeefc7f67c0890cdbaebf40c5b54.svg";
export { ForwardRef as ReactComponent };